import ClickAwayListener from "@material-ui/core/ClickAwayListener"
import Grow from "@material-ui/core/Grow"
import IconButton, { IconButtonProps } from "@material-ui/core/IconButton"
import ShareIcon from "@material-ui/icons/Share"
import React, { useState } from "react"
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  PinterestIcon,
  PinterestShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share"
import styled from "styled-components"

interface IIconButton extends IconButtonProps {
  selected: boolean
}
const Icon = styled(IconButton)<IIconButton>`
  z-index: 10;
  background-color: ${({ theme }) => theme.palette.secondary.main};
  color: ${({ theme, selected }) =>
    selected
      ? theme.palette.secondary.light
      : theme.palette.secondary.contrastText};

  transition: all ${({ theme }) => theme.transitions.duration.standard}ms
    ease-in-out;

  :hover {
    background-color: ${({ theme }) => theme.palette.secondary.dark};
  }
`

const BtnWrapper = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  flex-wrap: nowrap;

  > button {
    margin-right: ${({ theme }) => theme.spacing(1)}px;
  }

  > .react-share__ShareButton {
    transform: translateY(5px) !important;
  }
`

interface IProps {
  className?: string
  url: string
  title?: string | undefined
  media?: string
  emailBody?: string
}

const ShareButton: React.FC<IProps> = ({
  className,
  url,
  title,
  media,
  emailBody,
}) => {
  const [clicked, setClicked] = useState(false)

  const flip = () => setClicked(c => !c)
  const handleClose = () => setClicked(false)

  return (
    <div className={className}>
      <ClickAwayListener onClickAway={handleClose}>
        <BtnWrapper>
          <Icon onClick={flip} selected={clicked}>
            <ShareIcon />
          </Icon>

          <Grow in={clicked}>
            <FacebookShareButton url={url}>
              <FacebookIcon size={40} round />
            </FacebookShareButton>
          </Grow>

          <Grow
            in={clicked}
            style={{ transformOrigin: "0 0 0" }}
            {...(clicked ? { timeout: 1000 } : {})}
          >
            <WhatsappShareButton url={url} title={title}>
              <WhatsappIcon size={40} round />
            </WhatsappShareButton>
          </Grow>

          <Grow
            in={clicked}
            style={{ transformOrigin: "0 0 0" }}
            {...(clicked ? { timeout: 2000 } : {})}
          >
            <TelegramShareButton url={url} title={title}>
              <TelegramIcon size={40} round />
            </TelegramShareButton>
          </Grow>

          <Grow
            in={clicked}
            style={{ transformOrigin: "0 0 0" }}
            {...(clicked ? { timeout: 3000 } : {})}
          >
            <LinkedinShareButton url={url}>
              <LinkedinIcon size={40} round />
            </LinkedinShareButton>
          </Grow>

          <Grow
            in={clicked}
            style={{ transformOrigin: "0 0 0" }}
            {...(clicked ? { timeout: 4000 } : {})}
          >
            <EmailShareButton url={url} subject={title} body={emailBody}>
              <EmailIcon size={40} round />
            </EmailShareButton>
          </Grow>

          {media && (
            <Grow
              in={clicked}
              style={{ transformOrigin: "0 0 0" }}
              {...(clicked ? { timeout: 5000 } : {})}
            >
              <PinterestShareButton url={url} media={media}>
                <PinterestIcon size={40} round />
              </PinterestShareButton>
            </Grow>
          )}

          <Grow
            in={clicked}
            style={{ transformOrigin: "0 0 0" }}
            {...(clicked ? { timeout: 6000 } : {})}
          >
            <TwitterShareButton url={url} title={title}>
              <TwitterIcon size={40} round />
            </TwitterShareButton>
          </Grow>
        </BtnWrapper>
      </ClickAwayListener>
    </div>
  )
}

export default ShareButton
